<template lang="pug">
  #main
    span(v-bind:data="paidstatus") Status: {{ paidstatus }}
    br
    a(href="/") Home
</template>

<script>
import { auth } from "firebase";
import axios from "axios";
import {env_config} from '../config/firebase'

export default {
  name: "Home",
  data() {
    return {
      paidstatus: ""
    };
  },
  methods: {
    verifyPayment: function(orderID) {
      auth()
        .currentUser.getIdToken(true)
        .then(idToken => {
          axios
            .post(
              env_config.url_api_root + "api/v1/verifypayment",
              {
                id: orderID
              },
              {
                headers: { Authorization: `Bearer ${idToken}` }
              }
            )
            .then(response => {
              
              if (!response.data.err) {
                this.paidstatus = response.data.message;
              } else {
                this.paidstatus = response.data.message;
              }
            })
            .catch(e => {
              console.log(e)
              // this.error.push(e);
            });
        });
    }
  },
  beforeMount() {
    this.verifyPayment(this.$route.params.orderid);
  },
  created() {}
};
</script>

<style>
</style>